module.exports = __webpack_public_path__ + "fonts/MyriadPro-Semibold.8ce5476.ttf";